/* eslint-disable no-underscore-dangle */
import PagingFeed from '../lib/PagingFeed';

class PagingTriggerTypeFeed extends PagingFeed {
  _getFeed() {
    return this._EntityDef.startTriggerTypesFeed(
      this._activeOrgId,
      this._filter,
      this._entityFields,
      this._sort,
      {skip: 0, limit: 100}
    );
  }

  _getDistinctValuesOfField(tenantId, field) {
    return this._EntityDef.startTriggerTypeDistinctValuesFeed(tenantId, field);
  }

  _getFeedIdsForSelection(tenantId, selection) {
    return this._EntityDef.loadTriggerTypeIdsForSelection(tenantId, selection);
  }

  getTriggerTypeEntitiesById(ids) {
    return this.getEntitiesById(ids);
  }

  getTriggerTypeEntitiesNameById(ids) {
    return this.getEntitiesNameById(ids);
  }

  getTriggerTypeEntityById(id) {
    return this.getEntityById(id);
  }
}

export default PagingTriggerTypeFeed;
